export * from './badge-tipo-empresa.pipe';
